import { ApiMethod, apiRequest } from '@mai-team-amusement/ui';
import {
  ReportApiPath,
  apiPath,
  zAuditPage,
  zGroupList,
  zHistory,
  zReportView,
  zRevisionList,
  zTeamReports,
  type SaveReportInput,
} from '@mai-work-report/contracts';

function withQuery(path: string, params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) {
      search.set(key, String(value));
    }
  }
  const text = search.toString();
  return text === '' ? path : `${path}?${text}`;
}

const week = (sub: string, weekStart: string) => ({ sub, weekStart });

export const reportApi = {
  report: (sub: string, weekStart: string) =>
    apiRequest(apiPath(ReportApiPath.Week, week(sub, weekStart)), zReportView),
  save: (sub: string, weekStart: string, input: SaveReportInput) =>
    apiRequest(apiPath(ReportApiPath.Week, week(sub, weekStart)), zReportView, {
      method: ApiMethod.Put,
      body: input,
    }),
  confirm: (sub: string, weekStart: string) =>
    apiRequest(apiPath(ReportApiPath.Confirm, week(sub, weekStart)), zReportView, {
      method: ApiMethod.Post,
    }),
  unconfirm: (sub: string, weekStart: string) =>
    apiRequest(apiPath(ReportApiPath.Unconfirm, week(sub, weekStart)), zReportView, {
      method: ApiMethod.Post,
    }),
  revisions: (sub: string, weekStart: string) =>
    apiRequest(apiPath(ReportApiPath.Revisions, week(sub, weekStart)), zRevisionList),
  history: (sub: string) => apiRequest(apiPath(ReportApiPath.History, { sub }), zHistory),
  team: (weeks: number, groupId?: number) =>
    apiRequest(withQuery(ReportApiPath.Team, { weeks, groupId }), zTeamReports),
  groups: () => apiRequest(ReportApiPath.Groups, zGroupList),
  auditLogs: (page: number, pageSize: number) =>
    apiRequest(withQuery(ReportApiPath.AuditLogs, { page, pageSize }), zAuditPage),
};

/** TanStack Query keys (prefixes invalidate everything below them). */
export const ReportQueryKey = {
  Report: ['report', 'week'],
  Revisions: ['report', 'revisions'],
  History: ['report', 'history'],
  Team: ['report', 'team'],
  Groups: ['report', 'groups'],
  Audit: ['report', 'audit'],
} as const;
